export default 'm9 15 3-7 3 7zm12.83 5.19-8-18a2 2 0 0 0-3.66 0l-8 18a2 2 0 0 0 3.66 1.62L7.08 19h9.84l1.25 2.81a2 2 0 0 0 3.66-1.62';